import { onDoLogout } from '@/redux/auth';
import clearSession from '@/helpers/fetcher/session/clearSession';
import { ApiService } from './ApiService';
import { NavigationService } from './NavigationService';
import { HomePageApiService } from './HomePageApiService';
import { TokenManager } from './TokenManager';

const hasInvalidTokens = () => !TokenManager.hasValidTokens();

const getDeviceState = () => ({
  isTrustedDevice: TokenManager.getIsTrustedDevice(),
  haveTrustedDevice: TokenManager.getHaveTrustedDevice(),
  isDeviceSuspended: TokenManager.getIsDeviceSuspended(),
  pinNeedChange: TokenManager.getPinNeedChange(),
  accessToken: TokenManager.getAccessToken(),
});

export const AuthService = {
  checkAndRedirectIfNoTokens: () => {
    if (hasInvalidTokens()) {
      clearSession();
      return true;
    }
    return false;
  },

  /**
   * Check authentication state and handle navigation
   * This should be called on every route change
   */
  async checkAuthAndNavigate(navigate, location) {
    if (hasInvalidTokens()) {
      return;
    }

    const { isPin6Digit, hasSetPin } = await ApiService.fetchPinTokenAndData();
    const { isTrustedDevice, haveTrustedDevice, isDeviceSuspended, pinNeedChange, accessToken } =
      getDeviceState();

    NavigationService.handleNavigation(
      isTrustedDevice,
      haveTrustedDevice,
      isDeviceSuspended,
      hasSetPin,
      pinNeedChange,
      isPin6Digit,
      accessToken,
      location,
      navigate
    );
  },

  /**
   * Fetch initial data for the application
   * This should be called once on app mount
   */
  async fetchInitialData(dispatch) {
    if (hasInvalidTokens()) {
      dispatch(onDoLogout());
      return;
    }

    const { pinToken } = await ApiService.fetchPinTokenAndData();
    const { accessToken } = getDeviceState();

    if (pinToken && accessToken) {
      HomePageApiService.callHomePageAPIs(dispatch);
    } else {
      HomePageApiService.setupRetryMechanism(dispatch, pinToken);
    }
  },

  /**
   * @deprecated Use checkAuthAndNavigate and fetchInitialData separately
   * This method is kept for backward compatibility
   */
  async initializeAuth(navigate, location, dispatch) {
    await this.checkAuthAndNavigate(navigate, location);
    await this.fetchInitialData(dispatch);
  },
};
